import apiService from '../../apiService';

const DOCUMENT_TEMPLATE_URL = 'documents/document-templates';

const documentTemplateService = {
  async uploadDocument(payload) {
    try {
      const response = await apiService.post(`/${DOCUMENT_TEMPLATE_URL}`, payload);
      return response.data;
    } catch (error) {
      throw error.response.data;
    }
  },

  async uploadBulkDocument(payload) {
    try {
      const response = await apiService.post(`/${DOCUMENT_TEMPLATE_URL}/bulk`, payload);
      return response.data;
    } catch (error) {
      throw error.response.data;
    }
  },

  async getDocument(id) {
    try {
      const response = await apiService.get(`/${DOCUMENT_TEMPLATE_URL}/${id}`);
      return response.data;
    } catch (error) {
      throw error.response.data;
    }
  },

  async updateDocument(payload, id) {
    try {
      const response = await apiService.post(`/${DOCUMENT_TEMPLATE_URL}/${id}`, payload);
      return response.data;
    } catch (error) {
      throw error.response.data;
    }
  },

  async deleteDocument(id) {
    try {
      const response = await apiService.delete(`/${DOCUMENT_TEMPLATE_URL}/${id}`);
      return response.data;
    } catch (error) {
      throw error.response.data;
    }
  },

  async downloadDocument(id) {
    try {
      const response = await apiService.get(`/${DOCUMENT_TEMPLATE_URL}/${id}/download`, { responseType: 'blob' });
      return response.data;
    } catch (error) {
      throw error.response.data;
    }
  },
};

export default documentTemplateService;